import FormsInterface from './FormsInterface';

export default class Forms implements FormsInterface{
  id: string
  label: string
  product_choice_element_id: string | null
  signature_block_id: string | null
  completeness_type: string | null

  constructor(id: string, label: string, product_choice_element_id: string | null, signature_block_id: string | null, completeness_type: string | null) {
    this.id = id
    this.label = label
    this.product_choice_element_id = product_choice_element_id
    this.signature_block_id = signature_block_id
    this.completeness_type = completeness_type
  }
}
